import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: true,
  selector: 'atom-navbar-icon',
  imports: [CommonModule, RouterModule, FontAwesomeModule],
  templateUrl: './navbar-icon.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
      .active .active-block {
        display: block;
      }
      .active .icon1 {
        opacity: 0 !important;
      }
      .active .image-active {
        opacity: 1 !important;
      }
      .active {
        background-color: #a9e5ce;
      }
      .ml003 {
        margin-left: 0.03rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarIconAtom {
  @Input() nav: any;
  @Input() currentPage: any;
  @Input() active = 'active';



}
